import { useState } from "react";
import restApiService from "../restApiService";
import { useDispatch } from "react-redux";
import { AlertType } from "../../shared/constants/enums";
import { toast } from "../../store/toastSlice";

function useGet() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const getService = async (url: string) => {
    setData(null);
    setLoading(true);
    setError("");
    try {
      const response = await restApiService.get(url);
      setData(response.data);
      setLoading(false);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.data?.message ||
        (error?.code?.includes("ERR_NETWORK")
          ? "Connection timed out. Please try again later."
          : "An unexpected error has occurred");
      setData(null);
      setLoading(false);
      setError(errorMessage);
      dispatch(
        toast({
          isOpen: true,
          message: errorMessage,
          type: AlertType.ERROR,
        })
      );
    }
  };
  return { data, loading, error, getService };
}

export default useGet;
